function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHourglass(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "m45.327 64h-26.654c-3.1205-0.001937-6.0849-1.3655-8.1169-3.7338-2.0036-2.3166-2.8965-5.3921-2.445-8.4215 1.4325-7.799 5.5937-14.834 11.739-19.845-6.1455-5.0128-10.306-12.049-11.737-19.85-0.45046-3.0272 0.44155-6.1004 2.4428-8.416 2.032-2.3683 4.9964-3.7319 8.1169-3.7338h26.654c3.1203 0.0030067 6.0842 1.3664 8.1169 3.7338 2.0015 2.3148 2.8953 5.3866 2.4482 8.4138-1.4448 7.8021-5.6135 14.838-11.763 19.852 6.1447 5.0197 10.307 12.058 11.746 19.861 0.44749 3.0279-0.44634 6.1006-2.4482 8.416-2.0318 2.3599-4.9899 3.7188-8.1039 3.7229zm0-58.667h-26.654c-1.5652-7.001e-4 -3.053 0.6812-4.0742 1.8674-0.99778 1.1359-1.4428 2.6545-1.216 4.1493 1.0028 6.6671 5.1303 12.907 12.267 18.553 1.3488 1.0677 1.3488 3.1142 0 4.1819-7.137 5.6502-11.257 11.895-12.267 18.557-0.22916 1.4973 0.21604 3.0192 1.216 4.1569 1.0214 1.1858 2.5091 1.8674 4.0742 1.8664h26.654c1.5651 0.0012 3.053-0.68033 4.0742-1.8664 0.99754-1.1338 1.4427-2.6507 1.216-4.1438-0.99517-6.6345-5.1205-12.877-12.267-18.566-1.3396-1.0676-1.3396-3.1034 0-4.171 7.1489-5.6883 11.274-11.933 12.267-18.568 0.22584-1.4979-0.2243-3.0188-1.229-4.1525-1.0181-1.183-2.5004-1.8646-4.0612-1.8674z",
    fill: "currentColor",
    style: {
      strokeWidth: 1.0876
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHourglass);
export default __webpack_public_path__ + "static/media/hourglass.33556073.svg";
export { ForwardRef as ReactComponent };